import { AiChatResourceType } from "components/ai_chat/types";
import { AiResourceType } from "lib/core_components/ai/types";
import { graphql } from "lib/generated/app-service-gql";
import { AiChatsQuery, AiChatsQueryVariables } from "lib/generated/app-service-gql/graphql";
import { useAiContext } from "lib/providers/AiContextProvider";
import { AiChatsResourceType } from "lib/types/graphQLEnums";
import { useGraphQlInfiniteQuery } from "../useGraphQlClient";

const pageSize = 25;

export function getResourceTypeEnum(
  resourceType: AiResourceType | AiChatResourceType,
): AiChatsResourceType {
  switch (resourceType) {
    case "BUYER_QA":
      return AiChatsResourceType.BuyerQa;
    case "BID_ASK_AI":
      return AiChatsResourceType.BidAskAi;
    case "BID_WRITING_QA":
      return AiChatsResourceType.BidWritingQa;
    case "CONTENT_LIBRARY_QA":
      return AiChatsResourceType.ContentLibraryQa;
    case "DOCUMENT_SINGLE_QA":
      return AiChatsResourceType.DocumentSingleQa;
    default:
      throw new Error(`Unsupported resource type for AI chats: ${resourceType}`);
  }
}

const aiChatsQuery = graphql(`
  query aiChats($req: AiChatsRequest!, $pagination: PaginationOptions!) {
    aiChats(AiChatsRequest: $req, PaginationOptions: $pagination) {
      conversationId
      title
    }
  }
`);

export function useAiChats() {
  const { resourceId, resourceType } = useAiContext();
  return useGraphQlInfiniteQuery<AiChatsQuery, AiChatsQueryVariables>(
    ["aiChats", resourceType, resourceId],
    aiChatsQuery,
    (page) => [
      {
        req: { resourceId, resourceType: getResourceTypeEnum(resourceType) },
        pagination: { page, pageSize },
      },
    ],
    {
      getNextPageParam: (lastPage, allPages) =>
        lastPage.aiChats.length === pageSize ? allPages.length + 1 : undefined,
      getPreviousPageParam: (_, allPages) => allPages.length - 1 || 1,
    },
  );
}
